import {
    req,
    axiosGet,
    reqJson,
    axiosPost
  } from '@/api/axiosFun';
  
  import {
    task_url
  } from '@/api/baseUrl';
  export const getTasks = () => {
    return req("get", task_url + '/tasks', null)
  };
 
/**
 * 任务消息API
 */

// 查询消息列表，支持分页和条件筛选
export const getTaskMessages = (params) => {
  // 特殊处理日期格式，防止Java解析错误
  const processedParams = { ...params };
  
  // 使用req方法处理GET请求
  const queryString = 
    Object.keys(processedParams)
      .map(key => {
        // 跳过null和undefined
        if (processedParams[key] === null || processedParams[key] === undefined) {
          return '';
        }
        
        // 统一处理时间参数，确保使用正确的参数名
        if (key === 'startTimeStr' || key === 'endTimeStr') {
          const value = encodeURIComponent(processedParams[key]);
          return `${key}=${value}`;
        }
        
        return `${key}=${encodeURIComponent(processedParams[key])}`;
      })
      .filter(item => item !== '') // 过滤掉空字符串
      .join('&');
      
  // 记录请求日志
  console.log('任务消息查询请求参数:', queryString);
  
  // 使用自定义URL
  return req("get", `${task_url}/message/list?${queryString}`, null);
};

// 标记单个消息为已读
export const markMessageAsRead = (messageId) => {
  return reqJson("post", task_url + '/message/mark-read', { messageId });
};

// 标记所有未读消息为已读
export const markAllMessagesAsRead = () => {
  return reqJson("post", task_url + '/message/mark-all-read', {});
};

// 获取未读消息数量
export const getUnreadMessageCount = () => {
  return axiosGet(`${task_url}/message/unread-count`);
};

// 获取消息列表
export function getMessageList(params) {
  return axiosGet(`${task_url}/message/list`, params);
}

// 获取消息详情
export function getMessageDetail(id) {
  return axiosGet(`${task_url}/message/${id}`);
}

// 标记消息已读
export function markMessageRead(id) {
  return axiosPost(`${task_url}/message/mark-read`, { messageId: id });
}

// 批量标记消息已读
export function markMessagesAsRead(ids) {
  return axiosPost(`${task_url}/message/mark-read/batch`, { ids });
}

// 全部标记已读
export function markAllAsRead() {
  return axiosPost(`${task_url}/message/mark-all-read`);
}

// 工单相关API

// 获取工单列表
export function getTicketList(params) {
  return axiosGet(`${task_url}/ticket/list`, params);
}

// 获取工单详情
export function getTicketDetail(ticketId, mode) {
  return axiosGet(`${task_url}/ticket/detail/${ticketId}`, { mode });
}

// 获取工单消息列表
export function getTicketMessages(ticketId, mode) {
  return axiosGet(`${task_url}/ticket/messages/${ticketId}`, { mode });
}

// 添加工单消息
export function addTicketMessage(data) {
  return axiosPost(`${task_url}/ticket/add-message`, data);
}

// 更新工单状态
export function updateTicketStatus(data) {
  return axiosPost(`${task_url}/ticket/update-status`, data);
}

// 创建工单
export function createTicket(data) {
  return axiosPost(`${task_url}/ticket/create`, data);
}

// 获取工单配置选项
export function getTicketConfig() {
  return axiosGet(`${task_url}/ticket/config`);
}

// 管理员工单相关API

// 获取待处理工单列表
export function getAdminPendingTickets(params) {
  return axiosGet(`${task_url}/ticket/admin/pending`, params);
}

// 获取所有工单列表
export function getAdminAllTickets(params) {
  return axiosGet(`${task_url}/ticket/admin/list`, params);
}

// 获取工单详情(管理员)
export function getAdminTicketDetail(id, params) {
  return axiosGet(`${task_url}/ticket/admin/detail/${id}`, params);
}

// 获取工单消息列表(管理员)
export function getAdminTicketMessages(ticketId, params) {
  return axiosGet(`${task_url}/ticket/admin/messages/${ticketId}`, params);
}

// 添加工单消息(管理员)
export function addAdminTicketMessage(data, params) {
  return axiosPost(`${task_url}/ticket/admin/add-message`, data, params);
}

// 更新工单状态(管理员)
export function updateAdminTicketStatus(data, params) {
  return axiosPost(`${task_url}/ticket/admin/update-status`, data, params);
}
 


// WEBPACK FOOTER //
// ./src/api/task.js